module.exports = __webpack_public_path__ + "static/media/review-2.79506662.png";